export default class ConsumerProductionPreference {
  constructor(minimumPercentOfNeedMet) {
    this.minimumPercentOfNeedMet = minimumPercentOfNeedMet;
  }
}
